import React from 'react';
import {
  Button,
  Tooltip,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material';
import theme from '../../themes/index.en';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { CustomFileInputProps } from './customFileInputProps';

const CustomLabeledFileInput: React.FC<CustomFileInputProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  autoFocus,
  required,
  error,
  disabled,
  helperText,
  acceptedExtensions,
  isRTL = false,
}) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <FormControl
      fullWidth
      margin="normal"
      error={error}
      sx={{
        direction: isRTL ? 'rtl' : 'ltr',
        textAlign: isRTL ? 'right' : 'left',
      }}
    >
      {label && (
        <Typography
          component="label"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 500,
            marginBottom: '8px',
            textAlign: isRTL ? 'right' : 'left',
          }}
        >
          {label}
          {required && (
            <span
              style={{
                marginLeft: '5px',
                color: theme.palette.error.main,
              }}
            >
              *
            </span>
          )}
        </Typography>
      )}
      <TextField
        id={name}
        value={value ? `File: ${value}` : acceptedExtensions || ''}
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              component="span"
              onClick={handleButtonClick}
              disabled={disabled}
              sx={{
                fontSize: '0.875rem',
                border: '0px',
              }}
            >
              <AttachmentIcon />
            </Button>
          ),
          readOnly: true,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        style={{ backgroundColor: theme.palette.background.default }}
        autoFocus={autoFocus}
        disabled={disabled}
      />
      <input
        ref={fileInputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={onChange}
        onBlur={onBlur}
      />
      {helperText && (
        <FormHelperText
          sx={{ textAlign: isRTL ? 'right' : 'left', color: theme.palette.error.main }}
        >
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomLabeledFileInput;
